import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { GenericHeaderBackButton } from 'src/consumer/components/MyPlansPage/MyPlanComponents'
import { getPrescriptionOfEventAsClinicAssistant } from 'src/consumer/services/featureServices'
import { PMPButton } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import ViewOnlyPrescriptionV2 from 'src/mentor/components/PrescriptionMakingPage/viewOnlyComponents/ViewOnlyPrescriptionV2'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessful,
} from 'src/mentor/helpers/utilityFunctions'
import { PrescriptionIndividualPageParent } from './ClinicManageBookingsPageStyles'

export default function ClinicPrescriptionPage() {
  const { clinicId, bookingId } = useParams()
  const [prescriptionData, setPrescriptionData] = useState()
  const [prescriptionViewSettings, setPrescriptionViewSettings] = useState()
  const [doctorEmrSections, setDoctorEmrSections] = useState()
  const [dataLoading, setDataLoading] = useState(false)

  async function setupForAssistant() {
    const response = await getPrescriptionOfEventAsClinicAssistant(bookingId)
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      const crData = getDataMapFromCommonResponse(response)
      setPrescriptionData(response?.data?.data?.metaPrescription)
      setPrescriptionViewSettings(crData?.prescriptionViewSettings)
      setDoctorEmrSections(crData?.doctorEmrSections)
    } else {
      setPrescriptionData(null)
    }
  }

  async function setThingsUp() {
    setDataLoading(true)
    await Promise.all([setupForAssistant()])
    setDataLoading(false)
  }

  useEffect(() => {
    setThingsUp()
  }, [])

  return (
    <>
      {dataLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <PrescriptionIndividualPageParent>
          <div
            className="hide-on-print"
            style={{
              margin: '0 auto 20px',
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              maxWidth: '800px',
            }}
          >
            <GenericHeaderBackButton
              clickfunction={() => window.history.back()}
              styles={{ cursor: 'pointer' }}
            />
            <PMPButton onClick={() => window.print()}>Print</PMPButton>
          </div>
          {/* <ViewOnlyPrescription prescriptionData={prescriptionData} /> */}
          <ViewOnlyPrescriptionV2
            prescriptionData={prescriptionData}
            prescriptionViewSettings={prescriptionViewSettings}
            doctorEmrSections={doctorEmrSections}
            forAssistant
          />
        </PrescriptionIndividualPageParent>
      )}
    </>
  )
}
